export const path = {
  patientsList: {
    route: "/my-patients/patients-list",
    link: () => path.patientsList.route,
  },
};
